export class AddImageModel {
    name: string;
    linkUrl: string;
    file: File;
  }